import { formatBytes } from '@clim/domain';
import { useEffect, useState } from 'react';
import { formatDate } from '@clim/client-core';
import { Empty } from '../components/ui';
import { useEngine } from '../lib/session';

const TYPE_LABEL: Record<string, string> = {
  'client.create': 'Création client',
  'client.update': 'Modification client',
  'client.delete': 'Suppression client',
  'dossier.create': 'Création dossier',
  'dossier.update': 'Modification dossier',
  'dossier.transition': 'Changement de statut',
  'dossier.assign': 'Affectation',
  'dossier.unassign': 'Retrait d’affectation',
  'dossier.delete': 'Suppression dossier',
  'comment.create': 'Commentaire',
  'comment.delete': 'Suppression de commentaire',
};

export function SyncIssuesPage() {
  const engine = useEngine();
  return (
    <section>
      <h1>Synchronisation</h1>
      <p className="muted">
        {engine.pendingCount} modification(s) et {engine.pendingUploads} fichier(s) en attente · dernière
        synchro : {formatDate(engine.lastSyncAt) || 'jamais'}
      </p>
      {engine.lastError && <p className="error-box">{engine.lastError}</p>}
      <button className="btn" onClick={() => void engine.sync()}>
        Synchroniser maintenant
      </button>
      <BrowserSpace />
      <h2>Alertes</h2>
      {engine.issues.length === 0 ? (
        <Empty>Aucune alerte.</Empty>
      ) : (
        <ul className="list">
          {[...engine.issues].reverse().map((i) => (
            <li key={i.id} className={`issue issue-${i.kind}`}>
              <div className="row-main">
                <strong>
                  {TYPE_LABEL[i.type] ?? i.type} — {i.kind === 'failed' ? 'refusée (échec)' : 'conflit'}
                </strong>
                <span>{i.message}</span>
                <span className="muted">{formatDate(i.at)}</span>
              </div>
              <button className="btn small" onClick={() => void engine.dismissIssue(i.id)}>
                OK
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

/** Place occupée dans ce navigateur : les données du hors-ligne et les fichiers pas encore envoyés, jamais les photos. */
function BrowserSpace() {
  const engine = useEngine();
  const [used, setUsed] = useState<number | null>(null);
  useEffect(() => {
    void navigator.storage?.estimate?.().then(
      (e) => setUsed(e.usage ?? null),
      () => setUsed(null),
    );
  }, [engine.pendingUploads]);
  return (
    <div className="card">
      <h2>Espace utilisé sur cet appareil</h2>
      <p>
        {used === null ? '—' : formatBytes(used)}
        {engine.pendingUploads
          ? ` · dont ${engine.pendingUploads} fichier(s) en attente d’envoi (supprimés de l’appareil dès leur envoi)`
          : ''}
      </p>
      <p className="muted">
        Seules les données nécessaires au travail hors ligne sont conservées (dossiers, clients, planning…).
        Les photos et documents restent dans le cloud : ils s’affichent à la demande et ne sont jamais stockés
        sur l’appareil.
      </p>
    </div>
  );
}
